import { render, staticRenderFns } from "./internalComment.vue?vue&type=template&id=947667fa&"
import script from "./internalComment.vue?vue&type=script&lang=ts&"
export * from "./internalComment.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports